/**
 * Licensed Materials - Property of IBM
* IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'jquery',
	'underscore',
	'text!./templates/menu.html'
], function (BaseView, $, _, template) {



	var FilterMenu = null;
	FilterMenu = BaseView.extend({

		templateString: template,

		events: {
			'click li': 'menuActionHandler',
			'keydown li': '_handleKeydown'
		},

		cacheMenuItems: null,

		/**
		* @param {Object} params.menuActionHandler - callback when a menu item is selected.
		*
		* @param {Object} options.onMenuHideHandler - callback when the menu receives the hide event
		*
		* @param {Object} options.onMenuShowHandler - callback when the menu receives the show event
		*
		*/
		init: function (params) {
			this.menuActionHandler = params.menuActionHandler;
			FilterMenu.inherited('init', this, arguments);
			this.onMenuHideHandler = params.onMenuHideHandler;
			this.onMenuShowHandler = params.onMenuShowHandler;

		},

		render: function(options){
			// Keep viewModel, mountNode, and isAuthoring so that updateMenuItems's render call uses.
			this.viewModel = options.viewModel || this.viewModel;
			this.mountNode = options.mountNode || this.mountNode;
			this.isAuthoring = options.isAuthoring || this.isAuthoring;

			if (!_.isEqual(this.cacheMenuItems, this.viewModel.menuItems)) {
				this.cacheMenuItems = this.viewModel.menuItems;

				if(this.mountNode){
					this.$el.empty();
					this.$el.html(this.dotTemplate(this.viewModel));
					this.mountNode.append(this.$el);
					if ( this.isAuthoring ) {
						this.showAuthoringMenuOptions();
					} else {
						this.showConsumeMenuOptions();
					}
					this._onRenderComplete();
				}else {
					throw new Error('No mount node is defined for filter menu');
				}
			}

			return Promise.resolve();
		},

		/**
		* @param {Array} Array of menuItems to be updated
		*/
		updateMenuItems: function(menuItems) {
			if (!menuItems || !this.viewModel) {
				return Promise.resolve({});
			}
			var menuItemActionIndexMap = this._getIndexMapOfMenuItemActions();

			//update menuItems in this.viewModel
			menuItems.forEach(function (itemSpec) {
				this.viewModel.menuItems[menuItemActionIndexMap[itemSpec.action]] = itemSpec;
			}.bind(this));

			return this.render({});
		},


		_getIndexMapOfMenuItemActions: function(){
			var indexMap = {};
			this.viewModel.menuItems.forEach(function(item, index){
				indexMap[item.action] = index;
			});
			return indexMap;
		},

		/**
		 *	Shows menu options that are only available in authoring mode.
		 */
		showAuthoringMenuOptions: function() {
			this.$el.find('[authoring-only="true"]').show();
		},

		/**
		 *	Hides menu options that are only available in authoring mode.
		 */
		showConsumeMenuOptions: function() {
			this.$el.find('[authoring-only="true"]').hide();
		},

		/**
		* Post render callback
		*/
		_onRenderComplete: function(){
			if(this.onMenuShowHandler){
				this.$el.parent().on('show.bs.dropdown', this.onMenuShowHandler);
			}

			if(this.onMenuHideHandler){
				this.$el.parent().on('hide.bs.dropdown', this.onMenuHideHandler);
			}

		},

		/**
		* When the drop down menu is shown we want to ensure it is scrolled into
		* view. For example, when the filter widget is at the bottom of the page
		* and the menu drops down it will not be seen unless the user explicitly
		* scrolls the display.
		*/
		onMenuShownHandler: function() {
			this.scrollIntoView();
		},

		toggle: function() {
			this.$('.dropdown-toggle').dropdown('toggle');
		},

		isOpen: function() {
			return this.$el.hasClass('open');
		},

		showDeleteMenuOnly: function() {
			var menuItems = this.$('.dropdown-menu li[data-action]');
			_.each(menuItems, function(item) {
				if ($(item).attr('data-action') !== 'filter-menu-delete-action') {
					$(item).addClass('disabled');
				}
			});
		},

		remove: function(){
			this.$el.parent().off('shown.bs.dropdown', this.onMenuShownHandler);
			this.menuActionHandler = null;
			if(this.onMenuShowHandler){
				this.onMenuShowHandler = null;
			}
			if(this.onMenuHideHandler){
				this.onMenuHideHandler = null;
			}

			this.viewModel = null;
			this.mountNode = null;
			this.isAuthoring = null;

			FilterMenu.inherited('remove', this);
		},

		_handleKeydown: function(e) {
			var keyCode = e.which || e.keyCode || e.charCode;
			var $target = $(e.target);
			var $nextFocus;
			switch (keyCode) {
				case 9: //tabkey
					if (e.shiftKey) {
						if ($target.hasClass('firstMenuItem')){
							$nextFocus = $target.closest('ul').find('.lastMenuItem');
							$nextFocus.focus();
							e.preventDefault();
						}
					} else {
						if ($target.hasClass('lastMenuItem')) {
							$nextFocus = $target.closest('ul').find('.firstMenuItem');
							$nextFocus.focus();
							e.preventDefault();
						}
					}
					break;
				case 13: // enter
					this.menuActionHandler(e); // eslint-disable-line
					// fall through intentional
				case 27: // escape
					this.toggle();
					$target.closest('.filter-dock-overflow').focus();

					break;
				default:
					break;
			}
		},

		/**
		 * Disables overflow menu options if there are no items in the filter dock and
		 * Enables overflow menu options if there are.
		 *
		 * @param {boolean} disable True if there are no items in the filter dock in given scope.
		 */

		toggleDisableOverflow: function(disable){

			let element = this.$el.find('.dropdown-menu li');

			element.toggleClass('data-action-disabled', disable);
			// Adds disable html code to dock that is empty in current scope
			if(element.hasClass('data-action-disabled') && element.parents('.wrapper').length === 0){
				element.wrap("<div class='wrapper'></div>");
			}
			// Removes disable html code to dock that is not empty in current scope
			if(!element.hasClass('data-action-disabled') && element.parents('.wrapper').length > 0){
				element.unwrap();
			}

		}
	});

	return FilterMenu;
});
